import { useMemo } from "react";
import {
  redirect,
  useLocation,
  useNavigate,
  useParams as useReactRouterParams,
  useSearchParams as useReactRouterSearchParams,
} from "react-router-dom";

export { redirect };

export type ReadonlyURLSearchParams = URLSearchParams;

export function useRouter() {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      push(href: string, options?: { scroll?: boolean }) {
        navigate(href);
        if (options?.scroll !== false) {
          requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0 }));
        }
      },
      replace(href: string, options?: { scroll?: boolean }) {
        navigate(href, { replace: true });
        if (options?.scroll !== false) {
          requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0 }));
        }
      },
      back() {
        navigate(-1);
      },
      forward() {
        navigate(1);
      },
      refresh() {
        navigate(0);
      },
      prefetch(_href: string) {
        return Promise.resolve();
      },
    }),
    [navigate],
  );
}

export function usePathname(): string {
  return useLocation().pathname;
}

export function useSearchParams(): ReadonlyURLSearchParams {
  const [searchParams] = useReactRouterSearchParams();
  return searchParams;
}

export function useParams<
  T extends Record<string, string | string[] | undefined> = Record<string, string | undefined>,
>(): T {
  return useReactRouterParams() as unknown as T;
}

export function useSelectedLayoutSegment(): string | null {
  return null;
}

export function useSelectedLayoutSegments(): string[] {
  return [];
}

export function notFound(): never {
  throw new Response("Not Found", { status: 404 });
}
